import React from "react";
import Heading from "../common/Heading";
import { about } from "../data/Data";
import { NavLink } from "react-router-dom";
// import swiming from '../../../public/assets/img/swimming.jpeg'
// import meeting from "../../../public/assets/img/resto.jpeg";

export default function About() {
  return (
    <>
      <div className="container py-5 px-0">
        <div className="container">
          <h6>Welcome to BGM Hotel & Restaurant</h6>
          <p>
            At BGM Hotel & Restaurant, we pride ourselves on offering a perfect
            blend of luxury, comfort, and personalized service. Located in the
            heart of Ghiloth, our hotel is a serene oasis for travelers seeking
            a memorable stay. Whether you're visiting for leisure or business,
            our thoughtfully designed spaces, warm hospitality, and world-class
            amenities promise an unparalleled experience.
          </p>
          <div className="row g-5 align-items-center">
            <div className="col-lg-6">
              <h6 className="section-title text-start text-warning text-uppercase">
                About Us
              </h6>
              <h1 className="mb-4">
                Welcome to
                <span className="text-warning text-uppercase"> BGM HOTEL</span>
              </h1>
              <h6>Relax in our Hotel</h6>
              <p className="mb-4 justify">
                From the moment you step into our hotel, you'll be greeted with
                facilities designed to make your stay effortless and enjoyable.
                Our 24/7 front desk, concierge service, and free parking ensure
                convenience at every turn. Guests can also enjoy high-speed
                WiFi, a fully-equipped fitness center, a relaxing spa, and
                recreational spaces to unwind after a long day. We strive to
                meet all your needs, making your time with us unforgettable.
              </p>
              <div className="row g-3 pb-4">
                {about.map((item, key) => (
                  <div
                    className="col-sm-4 wow fadeIn"
                    data-wow-delay="0.1s"
                    key={key}
                  >
                    <div className="border rounded p-1">
                      <div className="border rounded text-center p-4">
                        {item.icon}
                        <h2 className="mb-1" data-toggle="counter-up">
                          {item.count}
                        </h2>
                        <p className="mb-0">{item.text}</p>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
              <NavLink to={"/about"}>
                <button className="btn btn-primary-custom col-md-6 col-12" >
                  Explore More
                </button>
              </NavLink>
            </div>
            <div className="col-lg-6">
              <div className="row g-3">
                <div className="col-6 text-end">
                  <img
                    className="img-fluid rounded w-75 wow zoomIn"
                    data-wow-delay="0.1s"
                    src="/assets/img/about-1.jpeg"
                    style={{ marginTop: "25%" }}
                  />
                </div>
                <div className="col-6 text-start">
                  <img
                    className="img-fluid rounded w-100 wow zoomIn"
                    data-wow-delay="0.3s"
                    src="/assets/img/about-2.jpeg"
                  />
                </div>
                <div className="col-6 text-end">
                  <img
                    className="img-fluid rounded w-50 wow zoomIn"
                    data-wow-delay="0.5s"
                    src="/assets/img/about-3.jpeg"
                  />
                </div>
                <div className="col-6 text-start">
                  <img
                    className="img-fluid rounded w-75 wow zoomIn"
                    data-wow-delay="0.7s"
                    src="/assets/img/about-4.jpeg"
                  />
                </div>
              </div>
            </div>

            {/* <div className="col-12 container py-5 justify"> */}
            <div className="col-12 container g-5 justify">
              <div className="text-center">
                <h6 className="section-title text-center text-warning text-uppercase">
                  Relax on Vacation
                </h6>
                <h1>ALL OFFERS</h1>
              </div>
              <div className="row aboutus book">
                <div className="col-lg-6 col-md-12 col-12 py-2">
                  <div className="card p-1">
                    <div className="card p-3">
                      <h1 className="text-warning text-uppercase">1</h1>
                      <h3>Swimming Pool</h3>
                      <div className="text-secondary">
                        <p>
                          Grab your bathing suit and hit the pool! It's time for
                          pool selfies. To make sure your pics are epic. We love
                          these essential summer captions for relaxing by the
                          water.
                        </p>
                        <ul>
                          <li htmlFor="">Keeping it cool in my pool.</li>
                          <li htmlFor="">
                            Relaxing needs a cool drink and even cooler water.
                          </li>
                          <li htmlFor="">
                            Close your eyes and feel the water around you.
                          </li>
                          <li htmlFor="">
                            Breathe - pool time is almost here.
                          </li>
                        </ul>
                        <img
                          src="/assets/img/swimming.jpeg"
                          alt=""
                          className="w-100 py-0"
                        />
                      </div>
                    </div>
                  </div>
                </div>

                <div className="col-lg-6 col-md-12 col-12 py-2">
                  <div className="card p-1">
                    <div className="card p-3">
                      <h1 className="text-warning text-uppercase">2</h1>
                      <h3>Meeting Area</h3>
                      <div className="text-secondary">
                        <p>
                          Plan meeting with us and experience the perfect blend
                          of comfort and functionality. Our meeting rooms are
                          equipped with high-speed WiFi and modern amenities to
                          ensure a seamless experience.
                        </p>
                        <ul>
                          <li htmlFor="">High-speed WiFi</li>
                          <li htmlFor="">Confirtable chairs</li>
                          <li htmlFor="">Big table for discussion</li>
                        </ul>
                        <img
                          alt=""
                          className="w-100 py-0"
                          src="/assets/img/resto.jpeg"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
